"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _objectSpread;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty = _interopRequireDefault(require("./defineProperty"));

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = (0, _keys.default)(source);

    if (typeof _getOwnPropertySymbols.default === 'function') {
      var _context;

      ownKeys = (0, _concat.default)(ownKeys).call(ownKeys, (0, _filter.default)(_context = (0, _getOwnPropertySymbols.default)(source)).call(_context, function (sym) {
        return (0, _getOwnPropertyDescriptor.default)(source, sym).enumerable;
      }));
    }

    (0, _forEach.default)(ownKeys).call(ownKeys, function (key) {
      (0, _defineProperty.default)(target, key, source[key]);
    });
  }

  return target;
}